import { decryptDataFromArray } from "helpers/EncDec";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { ReactSortable } from "react-sortablejs";
import { toast } from "react-toastify";
import { Button, Col, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import {
  CreateNewRoundTemplate,
  FetchAllRounds,
} from "services/RoundTemplateServices";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import four_dots from "../../assets/images/icon/four-dots.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";

const CreateRoundTemplateModal = ({
  t,
  addModal,
  setAddModal,
  fetchData,
  ...props
}) => {
  const [templateDetails, setTemplateDetails] = useState({});
  const [errors, setErrors] = useState({});
  const [allRounds, setAllRounds] = useState([]);

  const toggleAddModal = () => {
    setAddModal(!addModal);
    setTemplateDetails({});
    setErrors({});
  };

  const fetchAllRoundsFunction = async () => {
    try {
      let response = await FetchAllRounds();

      let responseData = decryptDataFromArray(response);

      setAllRounds(responseData?.roundList || []);
    } catch (error) {
      let errMsg =
        error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        "Error while fetching rounds";
      toast.error(errMsg);

      setAllRounds([]);
    }
  };

  useEffect(() => {
    if (addModal) {
      fetchAllRoundsFunction();
    }
  }, [addModal]);

  const handleAddRound = round => {
    let tempAllRounds = [...(allRounds || [])];
    tempAllRounds = tempAllRounds?.filter(r => r?.value !== round?.value);

    let selectedRounds = [...(templateDetails?.rounds || [])];

    if (round?.alias === "pre-assessment") {
      selectedRounds.unshift({ ...round });
    } else {
      selectedRounds.push({ ...round });
    }

    setAllRounds(tempAllRounds);
    setTemplateDetails(prev => ({
      ...prev,
      rounds: selectedRounds,
    }));

    if (selectedRounds?.length) {
      setErrors({
        ...errors,
        rounds: null,
      });
    } else {
      setErrors({
        ...errors,
        rounds: "Select atleast one round",
      });
    }

    setTimeout(() => {
      setErrors({
        ...errors,
        rounds: null,
      });
    }, 2500);
  };

  const handleRemoveRound = round => {
    let tempAllRounds = [...(allRounds || [])];
    tempAllRounds.push(round);

    let selectedRounds = [...(templateDetails?.rounds || [])];
    selectedRounds = selectedRounds?.filter(r => r?.value !== round?.value);

    setAllRounds(tempAllRounds);
    setTemplateDetails(prev => ({
      ...prev,
      rounds: selectedRounds,
    }));

    if (selectedRounds?.length) {
      setErrors({
        ...errors,
        rounds: null,
      });
    } else {
      setErrors({
        ...errors,
        rounds: "Select atleast one round",
      });
    }

    setTimeout(() => {
      setErrors({
        ...errors,
        rounds: null,
      });
    }, 2500);
  };

  const handleSaveClick = async () => {
    try {
      let errors = {};
      if (!templateDetails?.name?.trim()) {
        errors = {
          ...errors,
          name: "Name is required",
        };
      } else {
        errors = {
          ...errors,
          name: null,
        };
      }

      if (!templateDetails?.rounds?.length) {
        errors = {
          ...errors,
          rounds: "Select atleast one round",
        };
      } else {
        errors = {
          ...errors,
          rounds: null,
        };
      }

      if (Object.values(errors).some(val => !!val)) {
        setErrors(errors);

        setTimeout(() => {
          setErrors({});
        }, 2500);

        return;
      }

      let reqBody = {
        name: templateDetails?.name?.trim(),
        rounds: templateDetails?.rounds?.map((r, index) => ({
          interview_title_id: r?.value,
          round_order: index + 1,
        })),
      };

      let response = await CreateNewRoundTemplate(reqBody);

      let responseMsg =
        response?.data?.message || "Template Created Successfully";

      toast.success(responseMsg);

      setTimeout(() => {
        toggleAddModal();

        fetchData({});
      }, 1000);
    } catch (error) {
      let errMsg =
        error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        "Error while creating organization";

      let errors = error?.response?.data?.errors || {};
      setErrors(errors);

      setTimeout(() => {
        setErrors({});
      }, 2500);

      toast.error(errMsg);
    }
  };

  return (
    <Modal
      size="xl"
      isOpen={addModal}
      centered
      backdrop="static"
      toggle={toggleAddModal}
    >
      <ModalHeader tag="h4" toggle={toggleAddModal}>
        Add Template Details
      </ModalHeader>

      <ModalBody>
        <div className="">
          <Row className="">
            <Col md={12} className="">
              <Form.Group className="mb-2 floating-label">
                <Form.Label className="float-label">
                  Name<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  placeholder="Enter Name"
                  type="text"
                  name="name"
                  value={templateDetails?.name}
                  onChange={e => {
                    setTemplateDetails({
                      ...templateDetails,
                      name: e.target.value,
                    });
                    setErrors({
                      ...errors,
                      name: e?.target?.value?.trim()
                        ? null
                        : "Name is required",
                    });

                    setTimeout(() => {
                      setErrors({
                        ...errors,
                        name: null,
                      });
                    }, 2500);
                  }}
                  title="Name"
                />
                {errors?.name && <p className="text-danger">{errors?.name}</p>}
              </Form.Group>
            </Col>

            <Col md={12} className="mt-2">
              <Form.Group className="mb-2 floating-label">
                <Form.Label className="float-label">
                  Select Rounds<span className="text-danger">*</span>
                </Form.Label>

                <Row>
                  <Col lg={6} md={12}>
                    <Form.Group className="mb-4 floating-label round">
                      <Form.Label className="float-label">
                        Available Rounds
                      </Form.Label>

                      <div className="round-card">
                        {allRounds?.map(round => (
                          <div
                            key={round?.id}
                            className="available-round"
                            onClick={() => {
                              handleAddRound(round);
                            }}
                          >
                            <h4>
                              {round?.label} [{round?.round_type}]
                            </h4>
                            <span>
                              <img src={arrow_btn} alt="arrow_btn" />
                            </span>
                          </div>
                        ))}
                      </div>
                      {!templateDetails?.rounds?.length && errors?.rounds && (
                        <p className="text-danger"> {errors?.rounds} </p>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={12}>
                    <Form.Group className="mb-4 floating-label round">
                      <Form.Label className="float-label">
                        Selected Rounds
                      </Form.Label>

                      <div className="round-card">
                        <ReactSortable
                          list={templateDetails?.rounds || []}
                          setList={rounds => {
                            setTemplateDetails(prev => ({
                              ...prev,
                              rounds: rounds,
                            }));
                          }}
                          className="special-rounds-sa w-100"
                        >
                          {templateDetails?.rounds?.map((round, index) => (
                            <div
                              className="special-card-imdex"
                              key={round?.value}
                            >
                              <div className="selected-round available-round w-100">
                                <div className="d-flex align-items-center gap-3  four-rounds-ca">
                                  <span>
                                    <img src={four_dots} alt="four_dots" />
                                  </span>

                                  <div className="green-card-round">
                                    <h5>{`${index + 1}`}</h5>
                                  </div>

                                  <h4>{` ${round?.label} [${round?.round_type}]`}</h4>

                                  <div className="faexample-icon">
                                    <FontAwesomeIcon
                                      icon={faExclamation}
                                      id={`my-tooltip-${index + 1}`}
                                    />
                                    <Tooltip
                                      anchorSelect={`#my-tooltip-${index + 1}`}
                                      place="right"
                                      content={round.description}
                                      className="tooltip-max-width"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="delete-cod"
                                  onClick={() => handleRemoveRound(round)}
                                >
                                  <img src={delete_icon} alt="delete_icon" />
                                </div>
                              </div>
                            </div>
                          ))}
                        </ReactSortable>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Form.Group>
            </Col>

            <Col md={12} className="justify-content-center d-flex gap-2">
              <Button
                className="btn btn-primary reset"
                onClick={() => {
                  toggleAddModal();
                }}
              >
                Cancel
              </Button>
              <Button color="success" onClick={() => handleSaveClick()}>
                Save
              </Button>
            </Col>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CreateRoundTemplateModal;
